import React, { useState, useEffect, useRef } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@material-ui/data-grid";
import {
  assistanceTotal,
  obternerRegistroxID,
  getAllUsers,
} from "../utils/Actions";
import { size, isEmpty, reject } from "lodash";
import { Typography, Grid } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import moment from "moment/min/moment-with-locales";
import { GRID_DEFAULT_LOCALE_TEXT } from "../config/localeDatagrid";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import { Loading } from "../atoms";

import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
moment.locale("es");

function minsToHHMMSS(param) {
  const diff = new Date() - param;
  let hh = Math.floor(diff / 1000 / 60 / 60);
  let resultInMinutes = Math.round(diff / 60000);
  let mins_num = parseFloat(resultInMinutes, 10); // don"t forget the second param
  let hours = Math.floor(mins_num / 60);
  let minutes = Math.floor(mins_num - (hours * 3600) / 60);
  let seconds = Math.floor(mins_num * 60 - hours * 3600 - minutes * 60);

  // Appends 0 when unit is less than 10
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return hours + "H:" + minutes + "min";
}

const getRolDescription = (rol) => {
  if (Number(rol) === 1) {
    return "Seguridad";
  } else if (Number(rol) === 2) {
    return "Jefe de Operaciones";
  } else if (Number(rol) === 3) {
    return "Administrador";
  } else {
    return "Cliente";
  }
};

export default function InSite() {
  const [state, setstate] = useState([]);
  const [lista, setlista] = useState([]);
  const [visible, setVisible] = useState(false);
  let history = useHistory();

  const account = localStorage.getItem("Account");
  const accountJSON = JSON.parse(account);
  console.log(accountJSON);
  const { rol, accountAsigned, accountAsignedName } = accountJSON[0];

  const columns = [
    {
      field: "cuenta",
      headerName: "Lugar",
      width: 140,
      renderCell: (params) => <Typography> {params.value}</Typography>,
    },
    {
      field: "photo",
      headerName: "Foto",
      renderCell: (params) => (
        <Avatar src={params.value} style={{ width: 30, height: 30 }} />
      ),
      sortable: false,
      width: 81,
    },
    {
      field: "fullname",
      headerName: "Nombre Completo",
      description: "Esta columna no se puede ordener",
      width: 180,
      renderCell: (params) => <Typography> {params.value}</Typography>,
    },
    { field: "employeenumber", headerName: "#Usr.", width: 100 },

    {
      field: "registerday",
      headerName: "En Sitio Desde",
      width: 250,
      renderCell: (params) => (
        <Typography>{moment(params.value).format("lll")}</Typography>
      ),
    },
    rol !== 4 && {
      field: "entrydate",
      headerName: "Tiempo en Puesto",
      renderCell: (params) => (
        <Typography>{minsToHHMMSS(params.value)}</Typography>
      ),
      width: 200,
    },
  ];

  useEffect(() => {
    (async () => {
      let resultado = [];
      let final = [];
      let usuario;
      let ubicacion;
      setVisible(true);
      resultado = await assistanceTotal();
      const usuarios = (await getAllUsers()).data;
      const resultArray = await Promise.all(
        resultado.data.map(async (item) => {
          ubicacion = (await obternerRegistroxID("Accounts", item.accountId))
            .data.name;
          let userselected = usuarios.filter((row) => row.id === item.user);
          console.log("DATOS RELACIONADO");
          console.log(userselected);

          const data = {
            ...item,
            photo: userselected[0].photo,
            employeenumber: userselected[0].employeenumber,
            fullname: `${item.name} ${item.lastname}`,
            cuenta: ubicacion,
            registerday: item.registerday.toDate(),
            entrydate: item.entrydate.toDate(),
          };
          final.push(data);
        })
      );
      setstate(final);

      setVisible(false);
    })();
  }, []);

  const cargarInfo = async () => {
    let resultado = [];
    let final = [];
    let usuario;
    let ubicacion;
    setVisible(true);
    resultado = await assistanceTotal();
    resultado.data.map(async (item) => {
      usuario = (await obternerRegistroxID("Usuarios", item.user)).data;
      ubicacion = (await obternerRegistroxID("Accounts", item.accountId)).data
        .name;
      console.log({ ...item });
      const data = {
        ...item,
        photo: usuario.photo,
        employeenumber: usuario.employeenumber,
        fullname: `${item.name} ${item.lastname}`,
        cuenta: ubicacion,
        registerday: item.registerday.toDate(),
        entrydate: item.entrydate.toDate(),
      };

      final.push(data);
    });
    setlista(final);
    setstate(final);

    console.log("FINAL FINAL");
    console.log(final);
    setVisible(false);
    console.log("ESTADO");
    console.log(state);
  };

  const ExportCSV = ({ csvData, fileName }) => {
    let datauserexport = [];

    csvData.map((item) => {
      const data = {
        ID: item.id,
        RUTA_FOTO: item.photo,
        NOMBRE: item.name,
        APELLIDO: item.lastname,
        USUARIO: item.employeenumber,
        FECHA_CREACION: item.createdAt,
        ROL: getRolDescription(item.rol),
        CUENTA: item.accountAsignedName,
        CREADO_POR: item.createby,
        ESTATUS: item.status ? "Activo" : "Desactivo",
      };
      datauserexport.push(data);
    });

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const exportToCSV = (csvData, fileName) => {
      const ws = XLSX.utils.json_to_sheet(datauserexport);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    };

    return (
      <Button
        variant="outlined"
        color="secondary"
        onClick={(e) => exportToCSV(csvData, fileName)}
      >
        Exportar a Excel
      </Button>
    );
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ justifyContent: "flex-end", height: 80 }}>
        <ExportCSV csvData={state} fileName={"InSite"} />
      </GridToolbarContainer>
    );
  }

  return (
    <Grid
      container
      direction="column"
      style={{ height: "100vh", backgroundColor: "#fff", borderRadius: 5 }}
    >
      <Typography
        variant="h5"
        style={{
          marginBottom: 30,
          backgroundColor: "#fff",
          padding: 10,
          marginLeft: "auto",
          marginRight: "auto",
          borderRadius: 5,
        }}
      >
        <VerifiedUserIcon />
        Guardias En Turno
      </Typography>
      {size(state) > 0 && (
        <DataGrid
          rows={state}
          columns={columns}
          autoPageSize={true}
          localeText={GRID_DEFAULT_LOCALE_TEXT}
        />
      )}
      <Loading visible={visible} setVisible={setVisible} />
    </Grid>
  );
}
